import { render, staticRenderFns } from "./Plotly.vue?vue&type=template&id=50484c6a&scoped=true&"
import script from "./Plotly.vue?vue&type=script&lang=js&"
export * from "./Plotly.vue?vue&type=script&lang=js&"
import style0 from "./Plotly.vue?vue&type=style&index=0&id=50484c6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50484c6a",
  null
  
)

export default component.exports